






































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
@Component({})
export default class NPS extends Vue {
  /* Variables globales */
  private idClubPetco: any;
  private origenValor = 1; // BOPUS
  private tipoValor = 'NEU';
  form_submitting = false;
  private mensajeGlobal = '';
  private validacion = [(v: any) => v <= 6 || 'Only 80 in stock'];
  private comentarioValor = '';
  private opciones = [];
  // Circulo de carga
  private overlay = false;
  // SnackBar
  private snackbar = false;
  private text = '';
  private type = '';
  private timeout = 2500;
  // Variable componente Raiting 
  private emptyIcon = 'mdi-paw';
  private fullIcon = 'mdi-paw';
  private halfIcon = 'mdi-paw-half-full';
  private colorIcon = '#FFC100'
  private imageValor = require('../assets/imagenes/NPS_corgi_7-8.png')
  private raitingValor = 7;
  private valorColorIcon = '';
  private valorPregunta = '';
  // Dialog
  private dialogSuccess = false;
  private imgDialog = require('../assets/imagenes/success_dog.png');
  private textDialog = ''
  private dialogCalificacion: boolean = false;
  private dialogCalificacionComment: boolean = false;
  private urlToRedirect = this.$store.getters.paisCliente == 'CL' ? 'https://petco.cl' : 'https://petco.com.mx'; 
  //Mailer
  private mailer = {
    id: this.$store.getters.idUser,
    text: this.$store.getters.comentarioInsertado,
    idnps: 1
  }
  

  /* Métodos */
  private getValorPregunta() {
    let puntaje = this.$store.getters.puntaje;    
    let nombreUsuario = this.$store.getters.nombreCliente;
    if (this.isDefined(puntaje)) {
      if (puntaje <= 6) {
        if (puntaje === 1) {
          this.valorPregunta = nombreUsuario + ' por favor envíanos información sobre lo ocurrido para atenderte de inmediato';
        } else if (puntaje === 2 || puntaje === 3) {
          this.valorPregunta = nombreUsuario + ' por favor envíanos más información sobre lo ocurrido para que podamos contactarte a la brevedad';
        } else if (puntaje === 4 || puntaje === 5) {
          this.valorPregunta = nombreUsuario + ' por favor envíanos tus comentarios para poder darte una solución lo antes posible';
        } else if (puntaje === 6) {
          this.valorPregunta = 'Gracias ' + nombreUsuario + ', por favor envíanos tus comentarios, estos son importantes para que podamos mejorar';
        } else {
          this.valorPregunta = '¿Por qué no lo recomendarías?';
        }
        this.imageValor = require('../assets/imagenes/NPS_corgi_dislike.png');
      } else if (puntaje >= 7 && puntaje < 9) {
        this.valorPregunta = '¡Gracias ' + nombreUsuario + '! ¿Hay algo que podamos hacer para mejorar tu experiencia?';
        this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos con el equipo encargado para trabajar esta oportunidad'
        this.imageValor = require('../assets/imagenes/NPS_corgi_7-8.png');
      } else if (puntaje >= 9) {
        this.valorPregunta = '¡Gracias ' + nombreUsuario + '! ¿Hay algo más que te gustaría que hiciéramos por ti?';
        this.textDialog = 'Hemos recibido tu mensaje ¡Esperamos verte pronto!'
        this.imageValor = require('../assets/imagenes/In_Love.png');
      } else {
        this.valorPregunta = '';
        this.imageValor = require('../assets/imagenes/NPS_corgi_7-8.png');
      }
    }
  }

  private isDefined(param: any) {
    return param !== null && param !== undefined && param !== '';
  }

  private created() {
    if (this.isDefined(this.$store.getters.comentarioInsertado)) {
      this.comentarioValor = this.$store.getters.comentarioInsertado;
    }
    if (this.isDefined(this.$store.getters.puntaje)) {
      this.raitingValor = this.$store.getters.puntaje + 1;
    }
    if(this.raitingValor <= 6) {     
      this.tipoValor = 'NEG';
    } else if(this.raitingValor >= 7 && this.raitingValor < 9) {
      this.tipoValor = 'NEU';
    } else if(this.raitingValor >= 9) {
      this.tipoValor = 'POS';
    } 

    this.getValorPregunta();
  }

  // Metodo inserta comentario proporcionado por el cliente 
  private insertaComentario() {
    if (this.raitingValor === 0) {
      this.dialogCalificacion = true;
      return;
    }
    else if(this.raitingValor -1 <= 8 && this.comentarioValor.trim() === '') {
      this.dialogCalificacionComment = true;

      return;
    }

    this.overlay = true;
    let nombreMetodo = '';
    let data = {};
    // if (this.isDefined(this.$store.getters.idComentarioInsertado)) { // Ya se guardó (EDIT)
    //   data = {
    //     id_nps: this.$store.getters.idComentarioInsertado,
    //     ratingValor: this.raitingValor,
    //     origenValor: this.origenValor,
    //     tipoValor: this.tipoValor,
    //     comentarioValor: this.comentarioValor,
    //   }
    //   this.$store.dispatch('EditaComentario', {data: data})
    //   .then ((respuesta) => {
    //     if (respuesta.affectedRows === 1) {
    //       this.$store.commit('idComentarioInsertado', respuesta.insertId); // Guardamos el id del comentario guardado.
    //       this.$store.commit('comentarioInsertado', this.comentarioValor); // Guardamos comentario en store.
    //       this.$store.commit('puntaje', this.raitingValor); // Guardamos comentario en store.
    //       this.$store.dispatch("Predict", data)
    //       .then((resultado) => {  
    //         this.overlay = false;
    //         if (this.isDefined(resultado.name) && resultado.name === 'Error') {
    //           // this.createSnackBar('Error al procesar tu solicitud, intenta más tarde', 'error');
    //           this.dialogSuccess = true;
    //           window.location.href = 'https://petco.com.mx';
    //         } else {
    //           if (this.validaPreguntas(resultado)) {
    //             // AQUI EL DESMADRE DEL EMAIL
    //             //AQUI ES EL MAILER
    //             this.mailer.text = this.comentarioValor;
    //             this.$store.commit('preguntas', resultado);
    //             if (resultado.clave1 == '99-999') {
    //               this.$store.dispatch('EmailSend', this.mailer);
    //               this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
    //               this.dialogSuccess = true;
    //               this.$store.dispatch('LimpiaState'); // Limpieza de store.
    //               // setTimeout(() => {
    //               //   window.location.href = 'https://petco.com.mx';
    //               // });
    //             } else if (resultado.clave1 == '99-998') {
    //                 this.$store.dispatch('EmailSend', this.mailer);
    //                 this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
    //                 this.dialogSuccess = true;
    //                 this.$store.dispatch('LimpiaState'); // Limpieza de store.
    //                 // setTimeout(() => {
    //                 //   window.location.href = 'https://petco.com.mx';
    //                 // });
    //             } else if (resultado.clave1 == '99-997') {
    //                 this.$store.dispatch('EmailSend', this.mailer);
    //                 this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
    //                 this.dialogSuccess = true;
    //                 this.$store.dispatch('LimpiaState'); // Limpieza de store.
    //                 // setTimeout(() => {
    //                 //   window.location.href = 'https://petco.com.mx';
    //                 // });
    //             } else if (resultado.clave1 == '99-996') {
    //                 this.$store.dispatch('EmailSend', this.mailer);
    //                 this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
    //                 this.dialogSuccess = true;
    //                 this.$store.dispatch('LimpiaState'); // Limpieza de store.
    //             } else if (resultado.clave1 == '8-48') {
    //                 this.$store.dispatch('EmailSend', this.mailer);
    //                 this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
    //                 this.dialogSuccess = true;
    //                 this.$store.dispatch('LimpiaState'); // Limpieza de store.
    //                 // setTimeout(() => {
    //                 //   window.location.href = 'https://petco.com.mx';
    //                 // });
    //             } else if (resultado.clave1 == '7-47') {
    //                 this.$store.dispatch('EmailSend', this.mailer);
    //                 this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
    //                 this.dialogSuccess = true;
    //                 this.$store.dispatch('LimpiaState'); // Limpieza de store.
    //                 // setTimeout(() => {
    //                 //   window.location.href = 'https://petco.com.mx';
    //                 // });
    //             } else if (resultado.clave1 == '5-4') {
    //                 this.$store.dispatch('EmailSend', this.mailer);
    //                 this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
    //                 this.dialogSuccess = true;
    //                 this.$store.dispatch('LimpiaState'); // Limpieza de store.
    //                 // setTimeout(() => {
    //                 //   window.location.href = 'https://petco.com.mx';
    //                 // });
    //             } else { 
    //                 this.$router.push('/preguntas_bopus');
    //             }
    //           } else {
    //             this.dialogSuccess = true;
    //             this.$store.dispatch('LimpiaState'); // Limpieza de store.
    //             setTimeout(() => {
    //               window.location.href = 'https://petco.com.mx';
    //             }, 4500);
    //           }
    //         }
    //       })
    //       .catch((error) => {
    //       });
    //     }
    //   })  
    //   .catch ((error) => {});  
    // } else { // Primera vez que se guarda (CREATE)

      if (this.comentarioValor.trim() !== '' || this.comentarioValor.trim() === '') {
        this.form_submitting = true;
        data = {
          idClubPetco: this.$store.getters.idUser,
          ratingValor: this.raitingValor - 1,
          origenValor: this.origenValor,
          tipoValor: this.tipoValor,
          comentarioValor: this.comentarioValor,
          tiendaValor: this.isDefined(this.$store.getters.idTienda) ? this.$store.getters.idTienda : '7501',
          idCitaGrooming: this.isDefined(this.$store.getters.idCita) ? this.$store.getters.idCita : null,
          idEmpleado: this.isDefined(this.$store.getters.idEmpleado) ? this.$store.getters.idEmpleado : null,
          idUnico: this.isDefined(this.$store.getters.idUnico) ? this.$store.getters.idUnico : null       
        }
        this.$store.dispatch('GuardaComentario', data)
        .then ((respuesta) => {
          if (respuesta/*respuesta.affectedRows === 1*/) {
          this.form_submitting = false;
            this.$store.commit('idComentarioInsertado', respuesta.insertId); 
            this.$store.commit('comentarioInsertado', this.comentarioValor);
            this.$store.commit('puntaje', this.raitingValor - 1);
            this.dialogSuccess = true;
            //this.$store.dispatch("Predict", data)
            //.then((resultado) => {  
              this.overlay = false;
              if (this.isDefined(respuesta.name) && respuesta.name === 'Error') {
                this.createSnackBar('Error al procesar tu solicitud, intenta más tarde', 'error');
                this.dialogSuccess = true;
                window.location.href = 'https://petco.com.mx';              
              } else {
                if (this.isDefined(respuesta.duplicate) && respuesta.duplicate === true) {
                  this.createSnackBar('Ya has contestado con anterioridad esta encuesta', 'warning');
                  this.dialogSuccess = false;
                  return;
                }
                  //AQUI ES EL MAILER
                  this.mailer.text = this.comentarioValor;
                  this.$store.commit('preguntas', respuesta);
                  if (respuesta.clave1 == '199-199101') {
                    //this.$store.dispatch('EmailSend', this.mailer);
                    this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                    this.dialogSuccess = true;
                    this.$store.dispatch('LimpiaState'); // Limpieza de store.
                    // setTimeout(() => {
                    //   window.location.href = 'https://petco.com.mx';
                    // });
                  } else if (respuesta.clave1 == '99-998') {
                      //this.$store.dispatch('EmailSend', this.mailer);
                      this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve';
                      this.dialogSuccess = true;
                      this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      // setTimeout(() => {
                      //   window.location.href = 'https://petco.com.mx';
                      // });
                  } else if (respuesta.clave1 == '99-997') {
                      //this.$store.dispatch('EmailSend', this.mailer);
                      this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                      this.dialogSuccess = true;
                      this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      // setTimeout(() => {
                      //   window.location.href = 'https://petco.com.mx';
                      // });
                  } else if (respuesta.clave1 == '99-996') {
                    //this.$store.dispatch('EmailSend', this.mailer);
                    this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                    this.dialogSuccess = true;
                    this.$store.dispatch('LimpiaState'); // Limpieza de store.
                  } else if (respuesta.clave1 == '198-198101'|| respuesta.clave1 == '44998-44444998' || respuesta.clave1.includes('998')) {
                      //this.$store.dispatch('EmailSend', this.mailer);
                      //this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                      this.textDialog = respuesta.respuesta !== '' ? respuesta.respuesta : 
                      'Hemos recibido tu mensaje ¡Esperamos verte pronto!';
                      this.dialogSuccess = true;
                      this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      // setTimeout(() => {
                      //   window.location.href = 'https://petco.com.mx';
                      // }, 4500);
                  } else if (respuesta.clave1 == '197-197101' || respuesta.clave1 == '196-196101' || respuesta.clave1 == '44997-44444997'|| respuesta.clave1 == '44996-44444996') {
                      //this.$store.dispatch('EmailSend', this.mailer);
                      //this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                      this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos con el equipo encargado para trabajar esta oportunidad'
                      this.dialogSuccess = true;
                      this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      setTimeout(() => {
                        window.location.href = 'https://petco.com.mx';
                      }, 4500);
                  } else if (respuesta.clave1 == '5-4') {
                      //this.$store.dispatch('EmailSend', this.mailer);
                      this.textDialog = 'Tu mensaje está llegando al más alto nivel de escalación en nuestro corporativo. Un ejecutivo Petco te contactará en breve'
                      this.dialogSuccess = true;
                      this.$store.dispatch('LimpiaState'); // Limpieza de store.
                      // setTimeout(() => {
                      //   window.location.href = 'https://petco.com.mx';
                      // });
                  } else { 
                      this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos con el equipo encargado para trabajar esta oportunidad'
                      this.dialogSuccess = true;
                  }
                // } else {
                //   this.dialogSuccess = true;
                //   this.$store.dispatch('LimpiaState'); // Limpieza de store.
                //   setTimeout(() => {
                //     window.location.href = 'https://petco.com.mx';
                //   }, 4500);
                // }
              }
            // })
            // .catch((error) => {
            // });
          }
        })  
        .catch ((error) => {});  
      } else { // Sin comentario
         this.dialogSuccess = true;
         this.$store.dispatch('LimpiaState'); // Limpieza de store.
         setTimeout(() => {
          window.location.href = 'https://petco.com.mx';
        }, 4500);
      }
    //} 
  }

  private createSnackBar (text: string, type: string) {
    this.snackbar = true;
    this.text = text;
    this.type = type;
  }

  private comentarioPuntuacion(rate: any) { 
    this.raitingValor = rate;
    this.validaValorRaiting()
    let nombreUsuario = this.$store.getters.nombreCliente;
    let rating = this.raitingValor - 1;
    if(rating <= 6) {
      if (rating === 1) {
        this.valorPregunta = nombreUsuario + ' por favor envíanos información sobre lo ocurrido para atenderte de inmediato';
      } else if (rating === 2 || rating === 3) {
        this.valorPregunta = nombreUsuario + ' por favor envíanos más información sobre lo ocurrido para que podamos contactarte a la brevedad';
      } else if (rating === 4 || rating === 5) {
        this.valorPregunta = nombreUsuario + ' por favor envíanos tus comentarios para poder darte una solución lo antes posible';
      } else if (rating === 6) {
        this.valorPregunta = 'Gracias '+ nombreUsuario + ', por favor envíanos tus comentarios, estos son importantes para que podamos mejorar';
      } else {
        this.valorPregunta = '¿Por qué no lo recomendarías?';
      }
      this.colorIcon = 'red'
      this.valorColorIcon = 'red';
      this.tipoValor = 'NEG';
      this.imageValor = require('../assets/imagenes/NPS_corgi_dislike.png');
    } else if(rating >= 7 && rating < 9) {
      this.colorIcon = '#FFC100';
      this.valorColorIcon = 'green';
      this.valorPregunta = '¡Gracias '+ nombreUsuario + '! ¿Hay algo que podamos hacer para mejorar tu experiencia?';
      this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos con el equipo encargado para trabajar esta oportunidad'
      this.tipoValor = 'NEU';
      this.imageValor = require('../assets/imagenes/NPS_corgi_7-8.png');
    } else if(rating >= 9) {
      this.colorIcon = 'blue';
      this.valorColorIcon = 'green';
      this.valorPregunta = '¡Gracias '+ nombreUsuario + '! ¿Hay algo más que te gustaría que hiciéramos por ti?';
      this.textDialog = 'Hemos recibido tu mensaje ¡Esperamos verte pronto!'
      this.tipoValor = 'POS';
      this.imageValor = require('../assets/imagenes/In_Love.png');
    }

  }

  // Valida si se recibieron preguntas para el usuario
  private validaPreguntas (array: any) {
    if (array.preguntas1.length > 0 || array.preguntas2.length > 0 || array.preguntas3.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  // Valida valor de puntaje para limitarlo de cero a diez
  private validaValorRaiting() {
    if (this.raitingValor >= 11) {
      this.raitingValor = 11;
    } else if (this.raitingValor < 0 ) {
      this.raitingValor = 0;
    }  
  }
}
